export const replaceTokens = (content: string, tokens: Record<string, string | number>) => {
	for (const key in tokens) {
		if (Object.prototype.hasOwnProperty.call(tokens, key)) {
			const value = tokens[key];
			content = content.replace(new RegExp(`{{${key}}}`, 'g'), `${value}`);
		}
	}
	return content;
};
